import { useCallback } from "react";
import { useKeyboardShortcut } from "./useKeyboardShortcut";
/**
 * Registers ⌘/Ctrl-Z (undo) and ⌘/Ctrl-Shift-Z (redo) on a container element.
 * Uses the capture phase so the shortcut wins over RF's internal key routing,
 * and calls `preventDefault` to keep the browser from surfacing its own undo.
 */ export function useUndoRedoShortcut(containerRef, handlers, options = {}) {
    const enabled = options.enabled ?? true;
    const onUndo = useCallback(()=>handlers.undo(), [
        handlers
    ]);
    const onRedo = useCallback(()=>handlers.redo(), [
        handlers
    ]);
    useKeyboardShortcut({
        target: containerRef,
        combo: "mod+z",
        handler: onUndo,
        enabled
    });
    useKeyboardShortcut({
        target: containerRef,
        combo: "mod+shift+z",
        handler: onRedo,
        enabled
    });
}

//# sourceMappingURL=useUndoRedoShortcut.js.map